import { Link } from '@tanstack/react-router'
import {
  WifiOff,
  ServerOff,
  LockKeyhole,
  ArrowRight,
  RefreshCw,
} from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Brand } from '@/features/shell/brand'

const states = {
  offline: {
    title: 'อุปกรณ์ออฟไลน์',
    copy: 'เชื่อมต่ออินเทอร์เน็ตเพื่อให้ระบบตรวจสอบสิทธิ์ก่อนเข้าพื้นที่ทำงาน',
    icon: WifiOff,
    label: 'OFFLINE',
    color: 'warning',
  },
  unavailable: {
    title: 'ติดต่อระบบไม่ได้ชั่วคราว',
    copy: 'ยังตรวจสอบเซสชันไม่ได้ นี่ไม่ได้หมายความว่ารหัสผ่านผิดหรือเซสชันหมดอายุ',
    icon: ServerOff,
    label: 'API UNAVAILABLE',
    color: 'warning',
  },
  expired: {
    title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
    copy: 'เซิร์ฟเวอร์แจ้งว่าเซสชันไม่มีผลแล้ว เข้าสู่ระบบเพื่อกลับไปยังพื้นที่ทำงาน',
    icon: LockKeyhole,
    label: 'AUTH REQUIRED',
    color: 'error',
  },
} as const
export function AvailabilityScreen({
  kind,
  retry,
}: {
  kind: keyof typeof states
  retry: () => void
}) {
  const state = states[kind]
  const Icon = state.icon
  return (
    <main className="center-screen">
      <Brand />
      <div className={`availability-icon ${state.color}`}>
        <Icon size={32} />
      </div>
      <span className="eyebrow">{state.label}</span>
      <h1>{state.title}</h1>
      <p className="muted max-w-md">{state.copy}</p>
      <p className="preservation-note">
        ข้อมูลทดสอบและรายการที่รอส่งในอุปกรณ์ยังคงอยู่
      </p>
      <div className="button-row">
        {kind === 'expired' ? (
          <Button asChild>
            <Link to="/login">
              เข้าสู่ระบบ <ArrowRight size={16} />
            </Link>
          </Button>
        ) : (
          <Button onClick={retry}>
            <RefreshCw size={16} /> ลองเชื่อมต่อใหม่
          </Button>
        )}
        <Button variant="outline" asChild>
          <Link to="/offline">ตรวจสอบอุปกรณ์</Link>
        </Button>
      </div>
    </main>
  )
}
